import { onDocumentReady } from "@theme/utilities";
import { PageViewEvent } from "@shopify/events";
//#region assets/page-view-event.ts
onDocumentReady(function dispatchPageViewEvent() {
	const template = document.querySelector("main[data-template]")?.dataset.template || "";
	document.dispatchEvent(new PageViewEvent({ page: {
		template,
		title: document.title,
		url: window.location.href
	} }));
}, { once: true });
//#endregion
